let Api = null
const winURl = window.location.host
const IS_PROD = ['production'].includes(process.env.NODE_ENV)
// 开发环境
if (!IS_PROD) {
  Api = 'https://gtpw-api-stag.zowoyoo.com' // 升级版 -- 预上线
  // Api = 'http://gtpw.zowoyoo.com:38087' // 正式环境
} else if (winURl === 'gtpw-stag.zowoyoo.com') {
  // 演示环境
  Api = 'https://gtpw-api-stag.zowoyoo.com'
} else {
  // 正式环境
  Api = 'http://gtpw.zowoyoo.com:38087'
}

export default Api


// WEBPACK FOOTER //
// ./src/utils/request.config.js